(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["athelas-bamboo"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('athelas-bamboo')) {
 customElements.define('athelas-bamboo', class extends HTMLElement {
  connectedCallback() {
   this.abort = new AbortController(); const signal = this.abort.signal;
   this.story = this.querySelector('.ab-story'); this.steps = [...this.querySelectorAll('[data-step]')];
   this.motion = matchMedia('(prefers-reduced-motion: reduce)');
   this.counter=this.querySelector('[data-counter]');this.mobileLine=this.querySelector('[data-mobile-line]');this.activeStep=-1;this.storyVisible=true;this.story.dataset.enhanced='true';
   this.update = () => { if(this.frame||!this.storyVisible)return; this.frame=requestAnimationFrame(()=>{this.frame=null;const vh=innerHeight;const box=this.story.getBoundingClientRect();if(box.bottom<=0||box.top>=vh)return;
    const stickyHeader=document.querySelector('.shopify-section-header-sticky');let headerOffset=0;if(stickyHeader){const r=stickyHeader.getBoundingClientRect();const position=getComputedStyle(stickyHeader).position;if((position==='sticky'||position==='fixed')&&r.top<=1&&r.bottom>0)headerOffset=Math.min(r.bottom,vh*.3)}this.style.setProperty('--header-offset',headerOffset+'px');
    const mobile=innerWidth<900&&matchMedia('(orientation:portrait)').matches;
    const progress=Math.max(0,Math.min(1,-box.top/Math.max(1,box.height-vh)));
    let closest=0;
    if(mobile){closest=Math.min(this.steps.length-1,Math.floor(progress*this.steps.length))}
    else{let distance=Infinity;this.steps.forEach((el,i)=>{const r=el.getBoundingClientRect();const d=Math.abs(r.top+r.height/2-vh*.5);if(d<distance){distance=d;closest=i}})}
    if(closest!==this.activeStep){this.activeStep=closest;this.story.dataset.active=String(closest+1);this.counter.textContent=String(closest+1).padStart(2,'0')+' / '+String(this.steps.length).padStart(2,'0');if(this.mobileLine)this.mobileLine.textContent=this.steps[closest].dataset.mobileLine||''}
    this.story.style.setProperty('--progress',(mobile?progress*100:(closest+1)/Math.max(1,this.steps.length)*100)+'%');
    if(!this.motion.matches){
     if(mobile){const frames=[{x:25,y:7,r:-7,s:.96},{x:-25,y:-5,r:5,s:.99},{x:25,y:5,r:-5,s:1},{x:-25,y:-4,r:7,s:.96}];const phase=Math.min(2.999,progress*3),i=Math.floor(phase),t=phase-i,e=t*t*(3-2*t),mix=k=>frames[i][k]+(frames[i+1][k]-frames[i][k])*e;this.story.style.setProperty('--x',mix('x').toFixed(1)+'px');this.story.style.setProperty('--shift',mix('y').toFixed(1)+'px');this.story.style.setProperty('--rotate',mix('r').toFixed(2)+'deg');this.story.style.setProperty('--scale',mix('s').toFixed(3))}
     else{this.story.style.setProperty('--shift',Math.round((progress-.5)*32)+'px');this.story.style.setProperty('--rotate',(-3+progress*6).toFixed(2)+'deg')}
    }
   })};
   this.storyObserver=new IntersectionObserver(entries=>{this.storyVisible=entries[0].isIntersecting;this.story.dataset.inview=String(this.storyVisible);if(this.storyVisible)this.update()},{rootMargin:'100px'});this.storyObserver.observe(this.story);
   addEventListener('scroll',this.update,{passive:true,signal});addEventListener('resize',this.update,{passive:true,signal});this.update();
   const form=this.querySelector('.ab-form'); const button=this.querySelector('[data-add]'); const picker=form?.querySelector('select');
   picker?.addEventListener('change',()=>{const option=picker.selectedOptions[0];this.querySelector('[data-buy-price]').textContent=option.dataset.price;button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?button.dataset.sold:button.dataset.ready;},{signal});
   form?.addEventListener('submit',async event=>{event.preventDefault();if(button.disabled||!form.reportValidity())return;button.disabled=true;const before=button.textContent;button.textContent=this.querySelector('[data-loading]').textContent;const message=this.querySelector('[data-message]');message.textContent='';this.querySelector('[data-cart-link]').hidden=true;
    try { const body=new FormData(form); const cart=document.querySelector('cart-drawer')||document.querySelector('cart-notification');const sections=cart?.getSectionsToRender?.()||[];if(sections.length){body.set('sections',sections.map(s=>s.id).join(','));body.set('sections_url',location.pathname)}const root=this.dataset.root||'/';const response=await fetch(root+'cart/add.js',{method:'POST',body,headers:{Accept:'application/json'}});const data=await response.json();if(!response.ok||data.status)throw new Error(data.description||data.message||'Unable to add this item.');message.textContent=this.querySelector('[data-added]').textContent;this.querySelector('[data-cart-link]').hidden=false;if(cart&&data.sections){try{cart.classList.remove('is-empty');cart.renderContents(data);}catch(e){}}document.dispatchEvent(new CustomEvent('athelas:cart-added',{detail:data}));
    } catch(error){message.textContent=error instanceof TypeError?this.querySelector('[data-error]').textContent:error.message;}finally{button.disabled=picker.selectedOptions[0].dataset.available!=='true';button.textContent=before;}
   },{signal});
   const sticky=this.querySelector('[data-sticky]');const heroButton=this.querySelector('.ab-intro>.ab-button');const buyControls=this.querySelector('.ab-buy-controls');this.pastHero=false;this.heroCTAVisible=false;this.buyVisible=false;this.editing=false;const refreshSticky=()=>{sticky.hidden=(innerWidth<900?this.heroCTAVisible:!this.pastHero)||this.buyVisible||this.editing};
   this.observer=new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.target===heroButton){this.heroCTAVisible=e.isIntersecting;this.pastHero=!e.isIntersecting&&e.boundingClientRect.bottom<0}else this.buyVisible=e.isIntersecting});refreshSticky()},{threshold:0});this.observer.observe(heroButton);this.observer.observe(buyControls);addEventListener('resize',refreshSticky,{passive:true,signal});
   form?.addEventListener('focusin',e=>{if(e.target.matches('input,select')&&innerWidth<900){this.editing=true;refreshSticky()}},{signal});form?.addEventListener('focusout',()=>{this.editing=false;refreshSticky()},{signal});

  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.storyObserver?.disconnect();cancelAnimationFrame(this.frame);}
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["athelas-comfeel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('athelas-comfeel')) {
  customElements.define('athelas-comfeel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelectorAll('[data-gallery]').forEach(button => button.addEventListener('click', () => {
        const image = this.querySelector('[id^="acf-gallery-"]');
        if (!image) return;
        image.removeAttribute('srcset');
        image.src = button.dataset.src;
        image.alt = button.dataset.alt;
        this.querySelectorAll('[data-gallery]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }));
      const form = this.querySelector('form');
      if (!form) return;
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (this.busy) return;
        this.busy = true;
        const buttons = [...this.querySelectorAll('.purchase')];
        buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
        const status = this.querySelector('[data-status]');
        status.textContent = this.dataset.adding;
        let added = false;
        try {
          const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const sections = drawer && typeof drawer.getSectionsToRender === 'function'
            ? drawer.getSectionsToRender().map(item => item.id).slice(0, 5) : ['cart-icon-bubble'];
          if (drawer && typeof drawer.setActiveElement === 'function') drawer.setActiveElement(event.submitter);
          const body = new FormData(form);
          body.set('sections', sections.join(','));
          body.set('sections_url', window.location.pathname);
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/add.js', {method:'POST', headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body});
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
          added = true;
          status.textContent = this.dataset.added;
          this.querySelector('[data-view-cart]').hidden = false;
          try {
            if (drawer && typeof drawer.renderContents === 'function' && result.sections) {
              drawer.classList.remove('is-empty');
              drawer.renderContents(result);
            } else if (result.sections?.['cart-icon-bubble']) {
              const markup = new DOMParser().parseFromString(result.sections['cart-icon-bubble'], 'text/html');
              const target = document.getElementById('cart-icon-bubble');
              if (target) target.innerHTML = (markup.querySelector('.shopify-section') || markup.body).innerHTML;
            }
          } catch (_) {
            status.textContent = this.dataset.added;
          }
          document.dispatchEvent(new CustomEvent('athelas:cart-added', {detail:{variantId:body.get('id')}}));
        } catch (error) {
          status.textContent = error instanceof TypeError ? this.dataset.uncertain : error.message || this.dataset.error;
          this.querySelector('[data-view-cart]').hidden = false;
        } finally {
          this.busy = false;
          buttons.forEach(button => {button.disabled = false;button.removeAttribute('aria-busy');});
        }
      });
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
